import { BudgetOnboardingModalContent } from '@/components/cashflow/budget/BudgetOnboardingModalContent';
import PlentySpinner from '@/components/common/PlentySpinner';
import { Text } from '@/components/common/Typography';
import { Box, Center } from '@chakra-ui/react';

export const BudgetOnboardingModalLoading = () => (
    <Box borderRadius={6}>
        <BudgetOnboardingModalContent>
            <Center h={400}>
                <PlentySpinner message={<Text>Loading...</Text>} />
            </Center>
        </BudgetOnboardingModalContent>
    </Box>
);
